export default "__VITE_ASSET__7b01ebca__"